import Tabs from '@/js/tabs.js';

class FeaturedCollectionTabs extends Tabs {}

customElements.get('featured-collection-tabs') ||
  customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
